import axios, { AxiosResponse } from 'axios';
import config from "app/api/axiosConfig";
import { Resource } from 'app/api/types';
import get from 'lodash-es/get';

export default (token: string, albumId: string, resource: Resource, onUpload: (progress: number) => void, file?: File, preview?: File) => {
	const formData = new FormData();
	if (file) formData.append("photo", file);
	if (preview) formData.append("preview", preview);
	formData.append("resourceModel", JSON.stringify(resource));
	return axios({
		method: 'put',
		url: `${process.env.REACT_APP_GALLERY_HOST}/gallery/albums/${albumId}/resources`,
		data: formData,
		headers: config(token).headers,
		onUploadProgress: (e) => {
			onUpload(Math.round((e.loaded / e.total) * 100))
		},
	}).then((response: AxiosResponse) => {
		const resource: Resource = get(response, 'data', {});
		return Promise.resolve(resource);
	});
}
